<template>
  <div id="app">
    <DefaultLayout/>
  </div>
</template>

<script>
import { Capacitor } from '@capacitor/core';
import * as StatusBarPlugin from '@capacitor/status-bar';
import { SafeArea } from '@capacitor-community/safe-area';
import DefaultLayout from '@/views/layouts/DefaultLayout'

export default {
  components: {
    DefaultLayout,
  },
  beforeCreate() {
    if (Capacitor.isNativePlatform()) {
      StatusBarPlugin.StatusBar.setStyle({
        style: StatusBarPlugin.Style.Light,
      });

      SafeArea.enable({
        config: {
          statusBarColor: '#FFCC00',
          navigationBarColor: '#000000',
          navigationBarContent: 'light',
          statusBarContent: 'dark',
        },
      });
    }
  },
}
</script>
